export default __webpack_public_path__ + "static/media/Zinger.d7e183c4.png";